import 'css-chunksrc/client/scenes/workloads/scroll/scrollBar/styles.scss';export default {
  "scrollBar": "_scrollBar_4tgfq_1",
  "horizontal": "_horizontal_4tgfq_9",
  "content": "_content_4tgfq_12",
  "track": "_track_4tgfq_18",
  "thumb": "_thumb_4tgfq_26",
  "vertical": "_vertical_4tgfq_30",
  "dragging": "_dragging_4tgfq_56"
};